import '@/vendor/xpeng/element-styles'
import Sidebar from './src/sidebar.vue'

Sidebar.install = function (vue) {
  vue.component(Sidebar.name, Sidebar)
}

export default Sidebar
